import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=2a0af838&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=2a0af838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0af838",
  null
  
)

export default component.exports